module.exports = __webpack_public_path__ + "img/ComplispaceLogo.7884f67f.png";